import { render } from "./ExpandYour.vue?vue&type=template&id=5450e29e&scoped=true"
import script from "./ExpandYour.vue?vue&type=script&lang=js"
export * from "./ExpandYour.vue?vue&type=script&lang=js"

import "./ExpandYour.vue?vue&type=style&index=0&id=5450e29e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5450e29e"]])

export default __exports__